import clsx from "clsx";
import React, { ReactNode } from "react";
import { nanoid } from "nanoid";

import s from "~/components/Table/TableRow/SRRTableRow/TableRow.less";

interface ISrrRowBaseProps {
  leadingCells?: ReactNode[];
  cells: ReactNode[] | ReactNode[][];
}

const renderCell = (el: ReactNode) => (
  <td
    key={nanoid()}
    className={clsx(s.tdTO)}
    style={{ maxWidth: 100, overflow: "hidden" }}
  >
    <div>
      <span className={s.cont}>{el}</span>
    </div>
  </td>
);

const SrrRowBase = ({ leadingCells, cells }: ISrrRowBaseProps) => (
  <tr className={clsx(s.row_tr, s.row_td)}>
    {leadingCells?.map(renderCell)}
    {(Array.isArray(cells[0])
      ? (cells as ReactNode[][])
      : [cells as ReactNode[]]
    ).map((group) => group.map(renderCell))}
  </tr>
);

export default SrrRowBase;
